import React, { Component } from 'react';
import './App.css';
import logosData from './data/logos.json';
import navArrowSVG from './images/navarrow.svg'
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Swipeable from 'react-swipeable'
//import OddSlider from './OddSlider';



var img = "./images/sandwich_white.svg"
var _height="100px"
var _width="100px"
var _content={title: "none", company: "none", date: "none", location: "none", blurb:"none"}
var leftArrowClass="navArrow left"
var rightArrowClass="navArrow right"
var vimgScaleStyle= {transform: 'scale(1)'}
var currentSS=null
var startXpos={transform: 'translateX(0px)'}


class Overlay extends Component {
	constructor (props) {
		super(props)
    this.state = {
      cImgIndex:null,
      imgScale:90,
      imgScaleStyle: vimgScaleStyle,
      
    }


    this.handleClose=this.handleClose.bind(this)
    this.changeSS=this.changeSS.bind(this)
    this.swipedLeft=this.swipedLeft.bind(this)
    this.swipedRight=this.swipedRight.bind(this)
    this.handleResize=this.handleResize.bind(this)
    this.setImgXposStyle=this.setImgXposStyle.bind(this)
    this.swipingLeft=this.swipingLeft.bind(this)
    this.swipingRight=this.swipingRight.bind(this)
	}

  resetOverlayCounter(){
    this.setState({cImgIndex:null})
  }

  componentWillUpdate(nextProps, nextState) {
    if(nextProps.appImgObj !== null) {
      //console.log("current SS is"+JSON.stringify(nextProps.appImgObj))
      currentSS=nextProps.appImgObj.nextSSIndex-1
      img=nextProps.appImgObj.src
      _height=nextProps.appImgObj.height
      _width=nextProps.appImgObj.width
      _content.title=logosData[nextProps.projectState].title
      _content.company=logosData[nextProps.projectState].company
      _content.date=logosData[nextProps.projectState].date
      _content.location=logosData[nextProps.projectState].location
      _content.blurb=logosData[nextProps.projectState].blurb
    }
  }


  setImgXposStyle (val,dir){
    if(dir==="left"){
    var fstyle="translateX("+-val+"px)"
  } else if (dir==="right"){
    var fstyle="translateX("+val+"px)"
  }
  startXpos={transform: fstyle}
  }


    handleNavClick(page){
		  this.props.trayCB(page)
    }

    handleClose(){
      this.props.overlayCB(false)
      this.resetOverlayCounter()
    }

    handleResize (val){
      console.log("Resize"+val/100)
      var vscale='scale('+val/100+')'
      //this.setState.imgScale=scale
      var vimgScaleStyle= {transform: vscale, opacity: '.5'}
      this.setState({imgScaleStyle:vimgScaleStyle})
    }

    swiping(e, deltaX, deltaY, absX, absY, velocity) {
    //console.log("You're Swiping...", e, deltaX, deltaY, absX, absY, velocity)
  }

  swipingLeft(e, absX) {
    //console.log("You're Swiping to the Left...", e, absX)
    if(absX<300){
    this.setImgXposStyle(absX,"left")
  } else if (absX>=300){
    this.setImgXposStyle(1000,"left")
  }

  }

   swipingRight(e, absX) {
    //console.log("You're Swiping to the Left...", e, absX)
    if(absX<300){
    this.setImgXposStyle(absX,"right")
  } else if (absX>=300){
    this.setImgXposStyle(1000,"right")
  }
  }

  swiped(e, deltaX, deltaY, isFlick, velocity) {
    console.log("You Swiped...", e, deltaX, deltaY, isFlick, velocity)
  }

  swipedUp(e, deltaY, isFlick) {
    console.log("You Swiped Up...", e, deltaY, isFlick)
  }

  swipedLeft () {
    this.changeSS("prev")
  }

  swipedRight () {
    this.changeSS("next")
  }


    changeSS (dir){
      console.log("change screenshot")
      this.setState({cImgIndex:currentSS})
      if((dir==="prev" && this.props.appImgObj.prevSSIndex < 0) || (dir==="next" && this.props.appImgObj.nextSSIndex > this.props.ssArray.length-1)) {
        console.log("option should be inactive" + this.props.ssArray.length)
      } else {
        if(this.state.cImgIndex == null) {
          if(dir==="next") {  
            console.log("next was clicked")
            currentSS=this.props.appImgObj.nextSSIndex
          } else if (dir==="prev"){
            console.log("prev was clicked")
            currentSS=this.props.appImgObj.prevSSIndex
          }
        } else {
          if(dir==="next") {  
            currentSS=this.state.cImgIndex+1
          } else if (dir==="prev") { 
            currentSS=this.state.cImgIndex-1
          }
      }

      var tempObj=this.props.ssArray[currentSS]
      var tempNextSS=currentSS+1
      var tempPrevSS=currentSS-1
      var path="./images/screenshots/"+this.props.projectState+"/"
      var tempsrc=path+tempObj.imgsrc
      //console.log("path is "+path)
      var tempAppImgObj={src:tempsrc,nextSSIndex:tempNextSS,prevSSIndex:tempPrevSS,imgkey:currentSS,height:tempObj.height,width:tempObj.width}
      //setup new appImgObj with nextSSIndex,prevSSIndex, src,imgkey,height,width
      //console.log("showing next:"+JSON.stringify(tempAppImgObj))
      this.props.updateCB(tempAppImgObj,true)
      this.setState({cImgIndex:currentSS})
    }
    }

  render() {
    var slideDir="left"
    return (
        
      <div className="overlayOn" style={{display: this.props.overlayState ? 'flex' : 'none' }}>

      <div className="overlayBackground"><div onClick={this.handleClose} className="closeButton"></div></div>
      
      
      <div className="overlayContents">
          <div className="overlayCol1">
          <div className="overlayContentBlock dateTitleCo">
            <p className="light">{_content.date}</p>
            <p className="bold">{_content.title}<br />
            <span className="thin">{_content.company}, {_content.location}</span></p>
          </div>
          <div className="overlayContentBlock counterArrows">
          <div className="overlayNav">
      { /* OddSlider changeCB={this.handleResize} */}
          <div className="overlayCounter">{currentSS+1}/{this.props.ssArray.length}</div>
            <div className="overlayNavButtons">
                  <button onClick={() => this.changeSS("prev")} className={leftArrowClass}><img alt="left arrow" className="leftArrowImg" src={navArrowSVG} /></button>
                  <button onClick={() => this.changeSS("next")} className={rightArrowClass}><img alt="right arrow" className="rightArrowImg" src={navArrowSVG} /></button>
            </div>
      </div>
          </div>
              
              <div className="overlayContentBlock">
               <p>{_content.blurb}</p>
               </div>
          </div>
      <div className="overlayCol2">
      
       <Swipeable
        onSwiping={this.swiping}
        nodeName="swipecontainer"
        onSwipingLeft={this.swipingLeft}
        onSwipingRight={this.swipingRight}
        onSwipedLeft={this.swipedLeft}
        onSwipedRight={this.swipedRight}
        onSwiped={this.swiped}
        onSwipedUp={this.swipedUp} >
      <img className="overlayImg" alt={_content.title} style={this.startXpos} src={require(`${img}`)} height={_height} width={_width} />
      </Swipeable>
        </div>
      </div>
      </div>
     
    )
  }
}

export default Overlay;


// WEBPACK FOOTER //
// ./src/Overlay.js